"use client"

import { Text } from "@/elements"
import { FragmentType, useFragment } from "@/gql"
import { AuthenticatedCreativeJobDetailsFooterFragmentDoc } from "@/gql/graphql"
import { DocumentNode } from "@apollo/client"
import { FC, useState } from "react"
import { JobsDetailAuthenticatedFooterBanner } from "../JobDetails/JobDetailsAuthenticated/JobDetailsFooter/JobsDetailsAuthenticatedTopBanner/JobsDetailAuthenticatedFooterBanner"
import { JobsDrawerFooterSkeleton } from "../JobsDrawerFooterSkeleton"
import { WithdrawApplicationModal } from "../WithdrawApplication/WithdrawApplicationModal"

interface Props {
  jobPosting: FragmentType<typeof AuthenticatedCreativeJobDetailsFooterFragmentDoc> | undefined | null
  returnToJobDetails: () => void
  loading: boolean
  withdrawMutationRefetchQueries: DocumentNode[]
}

export const JobApplicationFooter: FC<Props> = ({
  loading,
  withdrawMutationRefetchQueries,
  returnToJobDetails,
  ...props
}) => {
  const jobPosting = useFragment(AuthenticatedCreativeJobDetailsFooterFragmentDoc, props.jobPosting)
  const [showWithdrawApplicationModal, setShowWithdrawApplicationModal] = useState(false)

  const jobApplication =
    jobPosting?.activeInteractionForCreative?.__typename === "JobApplication"
      ? jobPosting?.activeInteractionForCreative
      : null

  const jobInvitation =
    jobPosting?.activeInteractionForCreative?.__typename === "JobInvitation"
      ? jobPosting?.activeInteractionForCreative
      : null

  const isCreativeJobPosting = jobPosting?.__typename === "CreativeJobPosting"

  if (loading) {
    return <JobsDrawerFooterSkeleton />
  }

  return (
    <div className="flex w-full flex-col">
      <JobsDetailAuthenticatedFooterBanner
        jobApplication={jobApplication}
        jobInvitation={jobInvitation}
        isCreativeJobPosting={isCreativeJobPosting}
        jobPosting={jobPosting}
      />

      <div className="flex h-full w-full flex-row items-center justify-between">
        <div className="flex flex-col gap-y-1">
          <Text variant="h5">{jobPosting?.payString}</Text>
          <Text variant="label" className="text-fg-2" maxLines={1}>
            {jobPosting?.employmentTypeDisplay}
          </Text>
        </div>
        {jobApplication ? (
          <div className="flex flex-row items-center gap-2">
            <WithdrawApplicationModal
              showAdditionalOverlay
              isOpen={showWithdrawApplicationModal}
              onOpenChange={setShowWithdrawApplicationModal}
              applicationId={jobApplication?.id}
              withdrawMutationRefetchQueries={withdrawMutationRefetchQueries}
              onComplete={returnToJobDetails}
            />
          </div>
        ) : null}
      </div>
    </div>
  )
}
